/* Where the legal/disclosure pages live (served from public/ at our app root):
 *   /privacy                     Privacy Policy & Consent
 *   /consent-to-exchange-data    Consent to the Exchange of Data
 *   /credit-guide                Credit Guide
 *
 * On the hosted form these are same-origin, so relative links work. A
 * <script>-embedded form runs on the PARTNER'S origin — relative links would
 * point at their site — so embed.jsx stamps the bundle's own origin here at
 * load time (the embed script is always served from our host).
 */
let base = "";

export function setLegalBase(origin) {
  base = typeof origin === "string" ? origin.replace(/\/+$/, "") : "";
}

export const legalUrl = (path) => `${base}${path}`;
